import { useState } from "react";
import axios from "axios";

function AddClientTicket({ onClose }) {

const [title,setTitle]=useState("");
const [description,setDescription]=useState("");

const clearForm=()=>{

setTitle("");
setDescription("");

};

const saveTicket=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const clientId=
localStorage.getItem("client_id");

console.log(
"Client ID:",
clientId
);

const response=
await axios.post(

"https://saleupcall.com/api/Ticket/add-ticket.php",

{
client_id:clientId,
title:title,
description:description,
priority:"Medium"
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

console.log(
response.data
);

if(response.data.status){

alert(
"Ticket Created : "+
response.data.ticket_number
);

clearForm();
if(onClose){ onClose(); }
}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

alert(
"Error creating ticket"
);

}

};

return(

<div className="container-fluid p-3">



<div className="card-body">

<form onSubmit={saveTicket}>

<div className="mb-3">

<label className="form-label">

Title

</label>

<input
type="text"
className="form-control"
placeholder="Enter Title"
value={title}
onChange={(e)=>
setTitle(
e.target.value
)
}
required
/>

</div>

<div className="mb-3">

<label className="form-label">

Description

</label>

<textarea
className="form-control"
placeholder="Enter Description"
value={description}
onChange={(e)=>
setDescription(
e.target.value
)
}
rows="5"
required
/>

</div>

<div className="d-flex justify-content-end gap-2">

<button
type="button"
className="btn btn-secondary"
onClick={clearForm}
>

Cancel

</button>

<button
type="submit"
className="btn btn-success"
>

Create Ticket

</button>

</div>

</form>

</div>



</div>

);

}

export default AddClientTicket;